/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TestAndServiceReportEnum = 1 | 2 | 3 | 5;

export const TestAndServiceReportEnum = {
    NUMBER_1: 1 as TestAndServiceReportEnum,
    NUMBER_2: 2 as TestAndServiceReportEnum,
    NUMBER_3: 3 as TestAndServiceReportEnum,
    NUMBER_5: 5 as TestAndServiceReportEnum
};

